import trancheList from "./trancheList"
export default trancheList;
